import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ShieldCheck, Truck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { companyInfo } from '../mock';

export const Home = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Nước khoáng i-on kiềm | Trang chủ</title>
        <meta
          name="description"
          content="Khám phá thương hiệu nước khoáng i-on kiềm O2 với dịch vụ giao nhanh, sản phẩm an toàn và thông tin liên hệ rõ ràng."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://ionkiemo2.vn/" />
      </Helmet>
      {/* Hero Section */}
      <section className="relative min-h-screen pt-32 pb-20 px-4 bg-gradient-to-br from-cyan-50 via-blue-50 to-white overflow-hidden flex items-center 3xl:pt-40 3xl:pb-24 3xl:px-8 4xl:pt-48 4xl:pb-32 4xl:px-12">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMwNjkxYjIiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE4YzAtOS45NC04LjA2LTE4LTE4LTE4UzAgOC4wNiAwIDE4czguMDYgMTggMTggMTggMTgtOC4wNiAxOC0xOHptMCAyNGMwLTkuOTQtOC4wNi0xOC0xOC0xOFMyNCAzMi4wNiAyNCA0MnM4LjA2IDE4IDE4IDE4IDE4LTguMDYgMTgtMTh6TTAgNjBjMC05Ljk0IDguMDYtMTggMTgtMThzMTggOC4wNiAxOCAxOC04LjA2IDE4LTE4IDE4UzAgNjkuOTQgMCA2MHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-40"></div>
        <div className="container mx-auto relative z-10 max-w-screen-4xl 3xl:px-12 4xl:px-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center 3xl:gap-20">
            <div className="space-y-8">

              <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight 3xl:text-7xl 4xl:text-8xl">
                Nước đóng chai, đóng bình O2
                <span className="block text-cyan-600">đồng bộ cho mọi nhu cầu</span>
              </h1>

              <p className="text-xl text-slate-600 leading-relaxed 3xl:text-2xl 4xl:text-[28px]">
                Trang chủ cung cấp bức tranh tổng thể. Thương hiệu, sản phẩm, dịch vụ và kênh liên hệ nay đều có trang riêng để bạn tra cứu nhanh chóng.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 3xl:gap-6">
                <Link to="/about">
                  <Button size="lg" className="bg-cyan-600 hover:bg-cyan-700 text-white gap-2 w-full sm:w-auto shadow-lg hover:shadow-xl transition-all text-base 3xl:text-lg">
                    Khám phá thương hiệu
                  </Button>
                </Link>
                <Link to="/products">
                  <Button size="lg" variant="outline" className="border-2 border-cyan-600 text-cyan-600 hover:bg-cyan-50 gap-2 w-full sm:w-auto text-base 3xl:text-lg">
                    Xem sản phẩm
                  </Button>
                </Link>
              </div>

              <div className="flex items-center gap-6 pt-4 3xl:gap-10">
                <div className="flex items-center gap-2">
                  <div className="h-12 w-12 rounded-full bg-cyan-100 flex items-center justify-center 3xl:h-16 3xl:w-16">
                    <ShieldCheck className="h-6 w-6 text-cyan-600 3xl:h-8 3xl:w-8" />
                  </div>
                  <div>
                    <p className="font-bold text-slate-900 text-lg 3xl:text-xl">100%</p>
                    <p className="text-sm text-slate-600 3xl:text-base">An toàn</p>
                  </div>
                </div>
                <div className="h-12 w-px bg-slate-300 3xl:h-16"></div>
                <div className="flex items-center gap-2">
                  <div className="h-12 w-12 rounded-full bg-cyan-100 flex items-center justify-center 3xl:h-16 3xl:w-16">
                    <Truck className="h-6 w-6 text-cyan-600 3xl:h-8 3xl:w-8" />
                  </div>
                  <div>
                    <p className="font-bold text-slate-900 text-lg 3xl:text-xl">2 giờ</p>
                    <p className="text-sm text-slate-600 3xl:text-base">Giao hàng</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full blur-3xl opacity-20 animate-pulse"></div>
              <img 
                src={companyInfo.productImage} 
                alt="Nước khoáng i-on kiềm" 
                className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300 3xl:max-w-2xl 4xl:max-w-3xl"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
